import React from 'react';
import Logo from './LogoH';

function PageContainer({ children }) {
  return (
    <div className="page">
      <Logo width={50} style={{ marginRight: '1rem' }} />
      {children}
    </div>
  );
}

export default PageContainer;;